import Vue from 'vue';
import { VueAuthenticate } from 'vue-authenticate';
import config from '../config/auth.config';
import HttpService from './http.service';
import { getObjectProperty } from '../utils/auth';

// Required for vue-auth to hook into our http service
// To attach token to requests etc
Vue.prototype.$http = HttpService;

const instance = new VueAuthenticate(Vue.prototype.$http, config);
instance.onAuthSuccess = () => {};

instance.setToken = function setToken(response, tokenPath) {
  if (response[this.options.responseDataKey]) {
    response = response[this.options.responseDataKey];
  }

  const responseTokenPath = tokenPath || this.options.tokenPath;
  const token = getObjectProperty(response, responseTokenPath);

  if (token) {
    this.storage.setItem(this.tokenName, token);
    instance.onAuthSuccess(response, this.isAuthenticated());
  }
};

export default instance;
